<script setup lang="ts">
import { ref } from 'vue';

import { TSDialog, TSIcon, TSButton, formatDate, TSBadge } from 'tsv2-library';

import { ApprovalTransaction } from '@/types/approval.type';

const showApprovalDetail = ref<boolean>(false);

defineProps<{
  approvals: ApprovalTransaction[];
}>();
</script>
<template>
  <div class="flex items-center gap-1" data-ts-name="approval-list">
    <TSDialog
      v-model:visible="showApprovalDetail"
      :draggable="false"
      class="w-[400px]"
      closable
      header="Approval List"
      modal
    >
      <div
        :key="approval._id"
        v-for="approval in approvals"
        class="flex flex-col gap-2"
      >
        <div class="flex items-center justify-between">
          <span>Level {{ approval.level }} ({{ approval.type }})</span>
          <TSBadge
            v-if="approval.isDone"
            format="nowrap"
            label="Done"
            severity="success"
          />
        </div>
        <div class="flex flex-col gap-2" data-ts-section="approver-list">
          <div
            :key="approver.user._id"
            v-for="approver in approval.approvers"
            class="flex items-center justify-between"
            data-ts-section="approver-item"
          >
            <div class="flex items-center gap-1">
              <TSIcon class="h-4 w-4 text-general-400" icon="user" />
              <span
                class="text-primary-500"
                data-ts-section="transaction-detail-approver"
              >
                {{ approver.user.fullName }}
              </span>
            </div>
            <span v-if="approver.isNotInvolved">Not Involved</span>
            <span v-else-if="approver.approvedAt">
              {{ formatDate(approver.approvedAt, true) }}
            </span>
            <span v-else> Waiting for Approval... </span>
          </div>
        </div>
      </div>
    </TSDialog>
    <TSIcon class="h-4 w-4 text-general-400" icon="user" />
    <span
      class="text-primary-500"
      data-ts-section="transaction-detail-approver"
    >
      {{ approvals[0].approvers[0].user.fullName }}
    </span>
    <span v-if="approvals.every((approval) => approval.isDone)">
      {{ formatDate(approvals[0].approvers[0].approvedAt, true) }}
    </span>
    <TSButton
      @click="showApprovalDetail = true"
      class="hover:bg-transparent !p-0 h-max"
      data-ts-section="transaction-detail-more-approver-button"
      label="more"
      text
    />
  </div>
</template>
